import { Space, Typography } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';
import React, { useMemo } from 'react';

import { normalizePrepositionVSpacing, useAppSelector } from 'shared/lib';
import { sendEventOnClickChangeLocation } from 'shared/lib/sendGAEvents';

import { currentLocationSelector } from 'entities/locations';

import { UpdateUserCity } from 'features/UpdateUserCity';

import { LoansHeroFormSectionTexts } from 'widgets/LoansHeroFormSection/ui/LoansHeroFormSection.texts';

import styles from './HeroHeadingBlock.module.scss';

export const HeroHeadingBlock = () => {
  const isMobile = useIsMobile();
  const { nameLocative } = useAppSelector(currentLocationSelector);

  const headingText = useMemo(
    () => `${LoansHeroFormSectionTexts.headingText} ${normalizePrepositionVSpacing(nameLocative || '')}`,
    [nameLocative],
  );

  return (
    <Space
      direction="vertical"
      size={isMobile ? 8 : 20}
      className={styles.headingBlock}
    >
      <Typography.Heading level={2}>{headingText}</Typography.Heading>
      <UpdateUserCity onChangeCityClick={sendEventOnClickChangeLocation} />
      <Typography.Text className={styles.subtitleText}>{LoansHeroFormSectionTexts.subHeadingText}</Typography.Text>
    </Space>
  );
};
